import React, { useEffect } from 'react';
import { personalInfoType } from '../../../../common/interfaces/myProfile/personalDetails/personalInfo';
import { useAppSelector } from '../../../../infra/hooks';

interface PropsValues {
  setPersonalInfo: (data: personalInfoType) => void;
}

function DTOPersonalInfo({ setPersonalInfo }: PropsValues) {
  const selector = useAppSelector((state) => state.personalInfoSlice);

  useEffect(() => {
    const personal_Info_data: personalInfoType = {
      firstName: selector.firstName,
      lastName: selector.lastName,
      country: selector.country,
      DOB: selector.DOB,
      gender: selector.gender,
      martialStatus: selector.martialStatus,
      email: selector.email,
      phone: selector.phone,
      state: selector.state,
      education: selector.education,
      religious: selector.religious,
      nationalityId: selector.nationalityId,
      nationalityName: selector.nationalityName,
    };
    setPersonalInfo(personal_Info_data);
  }, [selector]);

  return <></>;
}
export default DTOPersonalInfo;
